import { Loader } from '@/components/Loader';

export function ChatLoadingState() {
  return (
    <div className="flex items-center justify-center h-full pt-16">
      <Loader />
    </div>
  );
}
